import React from 'react';
import './Error.scss';

const Error: React.FC = props => {
  return <div className="Error">{props.children}</div>;
};

export default Error;
